import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationShipping(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.SHIPPING, { keyPrefix });

  return t;
}

export default useTranslationShipping;
